import { render, staticRenderFns } from "./CsTermsOfUse.vue?vue&type=template&id=2e91b9b0&scoped=true"
import script from "./CsTermsOfUse.vue?vue&type=script&lang=js"
export * from "./CsTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2e91b9b0",
  null
  ,true
)

export default component.exports